
<form [formGroup]="comboForm">
  <kendo-floatinglabel text="{{label}}">
    <kendo-dropdownlist #combo
                        formControlName="comboValue"
                        [data]="data"
                        [disabled]="disabled"
                        required
                        (selectionChange)="selectionChange($event)">
    </kendo-dropdownlist>
  </kendo-floatinglabel>
</form>
